class AnalyticsServicePDPHelper extends AnalyticsService {
  constructor() {
    super();
    this.productName;
    this.productSwatchColorName;
    this.productType;
    this.productPrice;
    this.productId;
    this.productHandle;
    this.currency = this.getCurrency();
    this.init();
  }

  setProductDetails() {
    const product = document.querySelector("div[data-a-product-handle]");
    const {
      productTitle,
      productType,
      productPrice,
      productId,
      aProductHandle,
      productSwatchColorName,
    } = product.dataset;
    if (!product) {
      console.warn("Product details not found in the DOM.");
      return;
    }
    this.productName = productTitle;
    this.productType = productType;
    this.productPrice = parseFloat(productPrice);
    this.productId = productId;
    this.productHandle = aProductHandle;
    this.productSwatchColorName = productSwatchColorName || "unknown";
  }

  // HELPERS
  getProductPayload() {
    return {
      item_id: this.productId,
      item_name: this.productName,
      item_brand: "Aeyde",
      item_category: this.productType,
    };
  }
  getLowStockNotification(el) {
    let lowStockNotification = "none";
    const status =
      el.querySelector(`[data-stock-status]`)?.dataset?.stockStatus || "none";
    if (status === "yellow") {
      lowStockNotification = "yellow";
    } else if (status === "red") {
      lowStockNotification = "red";
    } else if (status === "sold-out") {
      lowStockNotification = "sold-out";
    }
    return lowStockNotification;
  }

  // init
  init() {
    this.setProductDetails();
    this.initSizeClick();
    this.initBreadcrumbClick();
    this.initAddToCart();
    this.initViewCart();
    this.initFamilyVariantClick();
    this.initPDPSectionTracking();
    this.initExternalLinkClick();
    this.initAccordionClick();
    this.initSizeGuideClick();
    this.initSelectColor();
    // add a listener for deferred PDP section tracking
    document.addEventListener(
      "analytics:PDPHelper:initDeferredPDPSectionTracking",
      () => {
        this.initPDPSectionTracking(true);
      }
    );
    if (window.__initDeferredPDPSectionTrackingFired) {
      this.initPDPSectionTracking(true);
    }
  }

  // CORE FUNCTIONS
  initSizeClick() {
    const sizeButtons = document.querySelectorAll(
      '[data-a-target-id="pdp-variant-option"]'
    );
    if (!sizeButtons.length) return;

    sizeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.dataset.value;
        const variantName = button.dataset.size;
        setTimeout(() => {
          const event = this.buildAnalyticsEvent("analytics:selectSize", {
            product_id: this.productId,
            product_name: this.productName,
            product_type: this.productType,
            price: this.productPrice,
            product_size: variantName,
            variant_id: variantId,
            low_stock_notification: this.getLowStockNotification(button),
            currency: this.currency,
            page_location: window.location.pathname,
          });
          document.dispatchEvent(event);
        }, 100);
      });
    });
  }
  initBreadcrumbClick() {
    const breadcrumbs = document.querySelectorAll(
      '[data-a-target="breadcrumb-link"]'
    );
    if (!breadcrumbs.length) return;

    breadcrumbs.forEach((breadcrumb) => {
      breadcrumb.addEventListener("click", (e) => {
        const event = this.buildAnalyticsEvent("analytics:breadcrumbClick", {
          page_location: window.location.pathname,
          breadcrumb_name: breadcrumb.textContent.trim(),
          handle: breadcrumb.getAttribute("href") || "unknown",
        });

        document.dispatchEvent(event);
      });
    });
  }
  initAddToCart() {
    let addToCartProcessing = false;
    document.addEventListener("analytics:PDPHelper:addToCart", (e) => {
      if (addToCartProcessing) return;
      addToCartProcessing = true;
      setTimeout(() => { addToCartProcessing = false; }, 2000);

      const event = this.buildAnalyticsEvent("analytics:addToCart", {
        ...this.getProductPayload(),
        value: this.productPrice,
        price: this.productPrice,
        product_handle: this.productHandle,
        product_swatch_color_name: this.productSwatchColorName,
        currency: this.currency,
      });
      document.dispatchEvent(event);
    });
  }
  initViewCart() {
    const viewCartButtons = document.querySelectorAll(
      '[data-a-target-id="view-cart"]'
    );

    const event = this.buildAnalyticsEvent("analytics:viewCart", {
      ...this.getProductPayload(),
      price: this.productPrice,
      product_handle: this.productHandle,
      currency: this.currency,
      page_location: window.location.pathname,
    });

    // listen for custom event -> re-dispatch analytics event
    document.addEventListener("analytics:PDPHelper:viewCart", () => {
      document.dispatchEvent(event);
    });

    // attach click handler to all matched buttons
    viewCartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        document.dispatchEvent(event);
      });
    });
  }
  initExternalLinkClick() {
    const externalLinks = document.querySelectorAll(
      '[data-a-target="external-link"], a[href="https://www.aeyde.com/pages/responsibility#made-in-italy"]'
    );
    if (!externalLinks.length) return;

    externalLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const event = this.buildAnalyticsEvent("analytics:externalLinkClick", {
          page_location: window.location.pathname,
          pdp_content_section: link.textContent.trim(),
          handle: this.productHandle,
        });

        document.dispatchEvent(event);
      });
    });
  }
  initFamilyVariantClick() {
    const familyLinks = document.querySelectorAll(
      '[data-a-target="family-link"]'
    );
    if (!familyLinks.length) return;

    familyLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const event = this.buildAnalyticsEvent("analytics:familyVariantClick", {
          handle: link.dataset.productHandle,
          product_name: link.dataset.productTitle,
          page_location: window.location.pathname,
        });

        document.dispatchEvent(event);
      });
    });
  }
  initAccordionClick() {
    const headings = document.querySelectorAll(
      '.product-accordions .heading'
    );
    if (!headings.length) return;

    headings.forEach((heading) => {
      heading.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:productAccordionClick", {
          ...this.getProductPayload(),
          accordion_heading: (heading.querySelector("span")?.textContent || heading.textContent).trim(),
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initSizeGuideClick() {
    const sizeGuideButton = document.querySelector("#size-guide-button");
    if (!sizeGuideButton) return;

    sizeGuideButton.addEventListener("click", () => {
      const event = this.buildAnalyticsEvent("analytics:sizeGuideClick", {
        ...this.getProductPayload(),
        page_location: window.location.pathname,
      });
      document.dispatchEvent(event);
    });
  }
  initSelectColor() {
    const swatches = document.querySelectorAll('[data-a-target="color-swatch"]');
    if (!swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const event = this.buildAnalyticsEvent("analytics:selectColor", {
          product_id: this.productId,
          product_name: this.productName,
          product_type: this.productType,
          product_color: swatch.getAttribute("title") || "unknown",
          handle: swatch.getAttribute("href") || "unknown",
          page_location: window.location.pathname,
        });
        document.dispatchEvent(event);
      });
    });
  }
  initPDPSectionTracking(deferred = false) {
    const sections = [
      {
        id: "suggested_products",
        event_name_prefix: "suggested_product",
        deferred: false,
      },
      {
        id: "discover_more",
        event_name_prefix: "discover_more",
        deferred: false,
      },
      {
        id: "recently_viewed",
        event_name_prefix: "recently_viewed",
        deferred: true,
      },
    ];

    sections.forEach(({ id, event_name_prefix, deferred: s_deferred }) => {
      if (deferred === s_deferred) {
        // find section container
        const container = document.querySelector(`[data-a-target="${id}"]`);
        if (!container) {
          console.warn(`PDP section with id ${id} not found.`);
          return;
        }

        const products = Array.from(
          container.querySelectorAll("[data-product-handle]")
        );
        if (products.length === 0) {
          console.warn(`No products found in PDP section ${id}.`);
          return;
        }

        // Track unique section view (first visible product)
        let hasViewed = false;
        const sectionObserver = new IntersectionObserver(
          (entries) => {
            if (hasViewed) return;
            if (entries.some((entry) => entry.isIntersecting)) {
              const event = this.buildAnalyticsEvent(
                "analytics:PDPSectionEvent",
                {
                  section_id: id,
                  page_location: window.location.pathname,
                  event_name: `${event_name_prefix}_unique_view`,
                }
              );
              hasViewed = true;
              document.dispatchEvent(event);
            }
          },
          { threshold: 0.5 }
        );
        sectionObserver.observe(container);

        // Track engaged view (last product in carousel)
        let hasEngagedView = false;
        const lastProduct = products[products.length - 1];
        const engagedObserver = new IntersectionObserver(
          (entries) => {
            if (hasEngagedView) return;
            if (entries[0].isIntersecting) {
              const event = this.buildAnalyticsEvent(
                "analytics:PDPSectionEvent",
                {
                  section_id: id,
                  event_name: `${event_name_prefix}_engaged_view`,
                  page_location: window.location.pathname,
                }
              );

              document.dispatchEvent(event);
              hasEngagedView = true;
            }
          },
          { threshold: 0.5 }
        );
        engagedObserver.observe(lastProduct);

        // Click tracking
        const clickedHandles = new Set();
        products.forEach((product) => {
          product.addEventListener("click", () => {
            const handle = product.dataset.productHandle;

            // total click - not needed
            // const totalEvent = this.buildAnalyticsEvent(
            //   "analytics:PDPSectionEvent",
            //   {
            //     section_id: id,
            //     event_name: `${event_name_prefix}_total_click`,
            //     handle: handle,
            //     product_id: product.dataset.productId,
            //     product_name: product.dataset.productTitle,
            //     product_type: product.dataset.productType,
            //   }
            // );

            // document.dispatchEvent(totalEvent);

            // unique click
            if (!clickedHandles.has(handle)) {
              clickedHandles.add(handle);
              const uniqueEvent = this.buildAnalyticsEvent(
                "analytics:PDPSectionEvent",
                {
                  section_id: id,
                  event_name: `${event_name_prefix}_unique_click`,
                  handle: handle,
                  product_id: product.dataset.productId,
                  product_name: product.dataset.productTitle,
                  product_type: product.dataset.productType,
                }
              );

              document.dispatchEvent(uniqueEvent);
            }
          });
        });
      }
    });
  }
}
